export default "__VITE_ASSET__CPs6Esca__"